module.exports = __webpack_public_path__ + "static/media/gray_17.5c216dff.jpg";